'use strict';

var React = require('react');

var SvgPageClockFilledMajor = function SvgPageClockFilledMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13 3.69v3.31h3.31l-3.31-3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75 12a.75.75 0 0 0-1.5 0v1.293c0 .331.132.65.366.884l.854.853a.75.75 0 0 0 1.06-1.06l-.78-.78v-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17 8.5v5.75a2.75 2.75 0 0 1-2.75 2.75h-4.421a4.5 4.5 0 1 1-3.579-7.938v-3.312a2.75 2.75 0 0 1 2.75-2.75h2.5v4a1.5 1.5 0 0 0 1.5 1.5h4Zm-10 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  }));
};
SvgPageClockFilledMajor.displayName = "PageClockFilledMajor";

exports.SvgPageClockFilledMajor = SvgPageClockFilledMajor;
